import React, { useEffect, useState } from "react"
import { Row, Col, Button, Container } from "reactstrap"

const TablePagination = ({
  totalCount,
  pageNumber,
  pageCount,
  onPageChange,
  data,
  pageSize,
  isSorting,
  onPageSizeChange,
}) => {
  const [inputPageNumber, setInputPageNumber] = useState(pageNumber)

  useEffect(() => {
    setInputPageNumber(pageNumber)
  }, [pageNumber])

  const handleNext = () => {
    const nextPage = pageNumber + 1
    onPageChange(nextPage)
    setInputPageNumber(nextPage)
  }

  const handlePrev = () => {
    const prevPage = pageNumber <= 1 ? 1 : pageNumber - 1
    onPageChange(prevPage)
    setInputPageNumber(prevPage)
  }

  const handleLastPage = () => {
    const lastPage = Math.ceil(totalCount / pageSize)
    onPageChange(lastPage)
    setInputPageNumber(lastPage)
  }

  const handleFirstPage = () => {
    onPageChange(1)
    setInputPageNumber(1)
  }

  //   const onChangeInInput = (event) => {
  //     const page = event.target.value > 0 ? Number(event.target.value) : 1;
  //     setInputPageNumber(page);
  //   };
  const onChangeInInput = event => {
    const inputValue = event.target.value
    const page = inputValue > 0 ? Number(inputValue) : 1
    setInputPageNumber(page)
    onPageChange(page)
  }

  const onChangeInSelect = event => {
    const size = Number(event.target.value)
    onPageSizeChange(size)
    onPageChange(1)
    setInputPageNumber(1)
  }

  return (
    <div className="pagination justify-content-end custom-pagination">
      {data && data.length > 0 && (
        <Col sm={2} className="me-3 p-2">
          <select
            className="form-select p-2"
            value={pageSize}
            onChange={onChangeInSelect}
          >
            {[10, 20, 30, 40, 50, 0].map(size => (
              <option key={size} value={size}>
                {size === 0 ? "All" : size}
              </option>
            ))}
          </select>
        </Col>
      )}

      {data && data.length > 0 && (
        <div className="pagination-controls d-flex justify-content-end align-items-center">
          <Container>
            <Row className="align-items-center">
              <Col className="col-md-auto">
                <div className="d-flex gap-1">
                  <Button
                    color="primary"
                    onClick={handleFirstPage}
                    disabled={pageNumber <= 1 || pageSize === 0}
                  >
                    {"<<"}
                  </Button>{" "}
                  <Button
                    color="primary"
                    onClick={handlePrev}
                    disabled={pageNumber <= 1 || pageSize === 0}
                  >
                    {"<"}
                  </Button>{" "}
                </div>
              </Col>
              <Col className="col-md-auto d-none d-md-block">
                <span>
                  Page{" "}
                  <strong>
                    {pageNumber} of{" "}
                    {pageSize === 0 ? 1 : Math.ceil(totalCount / pageSize)}
                  </strong>{" "}
                </span>
              </Col>
              <Col className="col-md-auto">
                <span>
                  | Go to page:{" "}
                  {/* <input
                    type="number"
                    value={inputPageNumber}
                    onChange={onChangeInInput}
                    disabled={pageSize === 0}
                    style={{ width: "50px", textAlign: "center" }}
                  /> */}
                  <input
                    type="number"
                    value={inputPageNumber}
                    onChange={onChangeInInput}
                    disabled={pageSize === 0}
                    style={{ width: "50px", textAlign: "center" }}
                  />
                </span>
              </Col>
              <Col className="col-md-auto">
                <div className="d-flex gap-1">
                  <Button
                    color="primary"
                    onClick={handleNext}
                    disabled={
                      pageNumber >= Math.ceil(totalCount / pageSize) ||
                      pageSize === 0
                    }
                  >
                    {">"}
                  </Button>{" "}
                  <Button
                    color="primary"
                    onClick={handleLastPage}
                    disabled={
                      pageNumber >= Math.ceil(totalCount / pageSize) ||
                      pageSize === 0
                    }
                  >
                    {">>"}
                  </Button>{" "}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </div>
  )
}

export default TablePagination
